"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = require("../utils");
var _image = _interopRequireDefault(require("./image"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/**
 * Creates an `Content image` content model
 *
 * @param {object} entity - The Contentful entry
 * @param {object} entity.sys - The sys properties for the entry
 * @param {object} entity.sys.id - The unique id for the entry
 * @param {string} entity.sys.contentType.sys.id - The content type id`
 * @param {object} entity.fields - The fields for the entry
 * @param {string} entity.fields.image - The image
 * @param {string} entity.fields.site - The site(s) this can be used on
 * @param {string} entity.fields.mobileWidth - The width for mobile
 * @param {string} entity.fields.mobilePosition - The position for mobile
 * @param {string} entity.fields.desktopWidth - The width for desktop
 * * @param {string} entity.fields.desktopPosition - The position for desktop
 * @param {string} entity.fields.caption - The caption
 * @returns {object} `contentImage` content model
 */
var createContentImage = function createContentImage(_ref) {
  var _sys$contentType;
  var sys = _ref.sys,
    fields = _ref.fields;
  return {
    id: (0, _utils.getProp)(sys, 'id'),
    contentType: (0, _utils.getProp)(sys === null || sys === void 0 ? void 0 : (_sys$contentType = sys.contentType) === null || _sys$contentType === void 0 ? void 0 : _sys$contentType.sys, 'id'),
    image: fields !== null && fields !== void 0 && fields.image ? (0, _image["default"])(fields.image) : null,
    site: (0, _utils.getProp)(fields, 'site'),
    mobileWidth: (0, _utils.getProp)(fields, 'mobileWidth'),
    mobilePosition: (0, _utils.getProp)(fields, 'mobilePosition'),
    desktopWidth: (0, _utils.getProp)(fields, 'desktopWidth'),
    desktopPosition: (0, _utils.getProp)(fields, 'desktopPosition'),
    caption: (0, _utils.getProp)(fields, 'caption')
  };
};
var _default = createContentImage;
exports["default"] = _default;